import SeatChoiceUIModel from './seat-choice';
import SeatChoiceDeltaUIModel from './seat-choice-delta';

class SegmentChoiceUIModel {
  constructor({
    fareType = null,
    isGenericSeat = false,
    newSeat = false,
    seat = undefined,
    seatSelectionFee = null,
    segmentCode = undefined,
    status = null,
    redeemedCP = false,
  } = {}) {
    this.fareType = fareType;
    this.isGenericSeat = isGenericSeat;
    this.newSeat = newSeat;
    this.seat = isGenericSeat ? new SeatChoiceDeltaUIModel(seat) : new SeatChoiceUIModel(seat);
    this.seatSelectionFee = seatSelectionFee;
    this.segmentCode = segmentCode;
    this.status = status;
    this.isPaid = false;
    this.redeemedCP = redeemedCP;
  }

  getTotal() {
    return this.seat.currency ? this.seat.getTotal() : (this.seatSelectionFee ? this.seatSelectionFee.total : 0);
  }

  getTotalPoints() {
    return this.seat.currency ? this.seat.getTotalPoints() : (this.seatSelectionFee ? this.seatSelectionFee.totalCPPoints : 0);
  }

  getTaxDetails() {
    return this.seat.currency ? this.seat.getTaxDetails() : (this.seatSelectionFee ? this.seatSelectionFee.taxDetails : null);
  }

  toApi() {
    return {
      '_meta':{
        'class':'SegmentChoice',
      },
      'seatSelectionFee': this.seatSelectionFee,
      'segmentCode': this.segmentCode,
      'isGenericSeat': this.isGenericSeat,
      'seat': this.seat.toApi(),
      'redeemedCP': this.redeemedCP,
    };
  }
}

export default SegmentChoiceUIModel;
